import { Text } from '@blueprintjs/core'
import { Link, usePage } from '@inertiajs/react'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Logo from 'images/logo.svg?react'
import { ClientPageProps } from 'types'

type TProps = {}

const Sidebar: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.ProfilePage)
  const {
    url,
    props: { user },
  } = usePage<ClientPageProps>()

  return (
    <aside className="fixed left-0 top-0 flex flex-col h-full justify-between w-96 p-12">
      <div className="flex flex-col gap-12">
        <Link
          href="/"
          className="flex items-center gap-4 text-palette-white hover:text-palette-white hover:no-underline"
        >
          <Logo className="h-9" />
          <Text tagName="span" className="font-title---50px uppercase">
            Digimarket
          </Text>
        </Link>
        <nav className="flex flex-col w-full lowercase gap-2">
          <li className="w-full">
            <Link href="/profile" className={`p1${url === '/profile' ? ' active' : ''} focus:outline-none`}>
              <Text tagName="span" className="font-body---20px text-palette-grey--alt [.active_&]:text-blue-500">
                {t('sidebar.home')}
              </Text>
            </Link>
          </li>
          <li className="w-full">
            <Link
              href="/profile/payments"
              className={`${url.match('/profile/payments') ? ' active' : ''} focus:outline-none`}
            >
              <Text tagName="span" className="font-body---20px text-palette-grey--alt [.active_&]:text-blue-500">
                {t('sidebar.payments')}
              </Text>
            </Link>
          </li>
        </nav>
      </div>
      <div className="flex flex-col gap-8">
        <div className="flex rounded-md p-2 gap-2 border-solid border border-palette-grey--50 items-center">
          <div className="w-8 h-8 rounded-full bg-palette-grey"></div>
          <div className="flex flex-col gap-0.5">
            <Text
              tagName="span"
              className="font-body---16px text-palette-grey"
            >{`${user?.first_name} ${user?.last_name}`}</Text>
            <Text tagName="span" className="font-body---14px text-palette-grey--50">{`${user?.email_address}`}</Text>
          </div>
        </div>
        <Link href="/sign_out" className="p-2">
          <Text tagName="span" className="font-body---20px text-palette-grey--alt">
            {t('sidebar.sign_out')}
          </Text>
        </Link>
      </div>
    </aside>
  )
}

export { Sidebar }
